import Agent from './agent'

const agent = new Agent()

export const historyService = {
  userDetails: () => agent.get(`/api/userinfo`),
}
